@import '../../../global/styles/media-queries.scss';
@import '../../../global/variables-arv.scss';
@import '../../../global/styles/focus.scss';

:host {
    .background {
        background-color: #1d2021;
        display: flex;
        flex-direction: column;

        .top,
        .bottom,
        .linedivider {
            width: 100%;
            max-width: var(--csb-content-width);
            box-sizing: border-box;
            margin-left: auto;
            margin-right: auto;

            @media screen and (max-width: 1490px) {
                padding-left: 24px;
                padding-right: 24px;
            }
        }

        .top {
            margin-top: 112px;
            margin-bottom: 64px;

            @include on-tablet-big {
                margin-top: 56px;
            }

            .grid {
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;

                @include on-tablet-big {
                    grid-template-columns: 1fr;

                    .icon {
                        margin-bottom: 64px;
                    }
                }
            }
        }

        .bottom {
            margin-top: 32px;
            margin-bottom: 32px;
            display: flex;
            flex-direction: row;

            .grid {
                display: flex;
                flex-direction: row;
                gap: 22px;

                @include on-tablet-big {
                    flex-direction: column;
                    align-items: start;
                    gap: 0;
                    row-gap: 24px;
                    margin-bottom: 56px;
                }
            }

            @include on-tablet-big {
                flex-direction: column;
                align-items: start;
            }
        }

        .column {
            display: flex;
            flex-direction: column;

            arv-button-animated {
                margin-right: auto;
            }
        }

        h2 {
            margin-top: 0;
            margin-bottom: 16px;
            color: white;
            font-family: var(--csb-font-family-roboto);
            font-weight: 700;
            font-size: 3.2rem;
            line-height: 3.2rem;
            text-transform: uppercase;
            font-stretch: condensed;

            @include on-tablet-big {
                font-size: 2.4rem;
                line-height: 2.4rem;
            }
        }

        p {
            font-family: var(--csb-font-family-roboto);
            font-weight: 400;
            font-size: 1.6rem;
            color: white;
            margin-top: 0;
            margin-bottom: 56px;
        }

        .linedivider {
            background-color: #787b80;
            height: 1px;
        }

        a {
            margin-right: 22px;
            font-weight: 400;
            font-size: 1.2rem;
            display: flex;
            color: white;
            background: none;
            border: none;
            outline: none;
            text-decoration: none;
            border-bottom: 1px solid white;
            padding: none;
            padding-bottom: 0.4rem;
            font: inherit;
            align-items: center;
        }

        .contact {
            margin-right: auto;
            font-size: 1.6rem;
            margin-bottom: 24px;
        }

        a:visited {
            color: white;
        }

        .social-icons {
            display: flex;
            flex-direction: row;
            margin-top: 36px;
            z-index: 5; // need this because profile page tab control overlaps it
            gap: 8px;

            a:focus-within .socials-svg {
                @include on-focus;
            }
        }

        .social {
            border: none;
            padding: none;
            margin-right: 50px;
        }

        .copyright {
            font-family: var(--csb-font-family-open-sans);
            font-weight: 400;
            font-size: 1.2rem;
            margin-left: auto;
            color: white;

            @include on-tablet-big {
                margin-left: 0;
            }
        }
    }
}
